
export function apiFetch( request ) {
	return {
		type: 'API_FETCH',
		request,
	};
}

export function setSettings( settings ) {
	return {
		type: 'SET_SETTINGS',
		settings,
	};
}

export function setSiteOptions( options ) {
	return {
		type: 'SET_SITE_OPTIONS',
		site_options: { ...options },
	};
}

export function updateSiteOptions( options ) {
	return {
		type: 'UPDATE_SITE_OPTIONS',
		site_options: { ...options },
	};
}
